import * as yup from 'yup';

function name(formatMessage, getApiUrl, get) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'NAME_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'NAME_SHOULD_BE_LESS_THAN_200_CHARS',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    )
    .test(
      'unique-name',
      formatMessage({
        id: 'NAME_MUST_BE_UNIQUE',
        defaultMessage: 'Name must be unique',
      }),
      async function uniqueName(value) {
        if (this?.options?.context?.name === value) return true;
        if (!value) return true;
        try {
          const response = await get(
            `${getApiUrl()}/sxcl/v1/rules?name=${value}`,
          );
          if (response?.ok) {
            return !(response?.data?.data?.length > 0);
          }
          throw new Error('name');
        } catch (e) {
          return this.createError({
            message: formatMessage({
              id: 'COULD_NOT_VALIDATE_UNIQUENESS_PLEASE_TRY_AGAIN',
              defaultMessage:
                'Could not validate uniqueness. Please try again.',
            }),
          });
        }
      },
    );
}

function conditions(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CONDITIONS_IS_REQUIRED',
      defaultMessage: 'Conditions is required',
    }),
  );
}

function outcome(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'OUTCOME_IS_REQUIRED',
      defaultMessage: 'Outcome is required',
    }),
  );
}

function isActive(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'IS_ACTIVE_IS_REQUIRED',
      defaultMessage: 'Is Active is required',
    }),
  );
}

const validationSchema = (formatMessage, getApiUrl, get) =>
  yup
    .object({
      name: name(formatMessage, getApiUrl, get),
      conditions: conditions(formatMessage),
      outcome: outcome(formatMessage),
      isActive: isActive(formatMessage),
    })
    .required();

export default validationSchema;
